import roleLevelApi from "../../api/rest/roleLevelApi";

const getAllRoleLevel = () => async (dispatch) => {
  const res = await roleLevelApi.getAll();
  if (res.data) {
    return res.data;
  }
  return null;
}

const getRoleLevelById = (roleLevels, roleLevelId) => {
  const roleLevel = roleLevels.find((roleLevel) => roleLevel.id === roleLevelId);
  return roleLevel;
}

const getRoleLevelByPracticeId = (practiceId) => async (dispatch) => {
  const res = await roleLevelApi.getRoleLevelByPracticeId(practiceId);
  if (res.data) {
    return res.data;
  }
  return null;
}

export const roleLevelBusiness = {
  getAllRoleLevel,
  getRoleLevelById,
  getRoleLevelByPracticeId
};

export default roleLevelBusiness;